export { default as About } from './About';
export { default as Advantages } from './Advantages';
export { default as Features } from './Features';
export { default as Integrations } from './Integrations';
export { default as Reviews } from './Reviews';
export { default as Team } from './Team';
export { default as VideoSection } from './VideoSection';
